var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228,56H160L133.333,36a20.12292,20.12292,0,0,0-12-4H76A20.0226,20.0226,0,0,0,56,52V72H36A20.0226,20.0226,0,0,0,16,92V204a20.0226,20.0226,0,0,0,20,20H188.88867A19.13289,19.13289,0,0,0,208,204.88867V184h20.88867A19.13289,19.13289,0,0,0,248,164.88867V76A20.0226,20.0226,0,0,0,228,56ZM184,200H40V96H80l26.667,20a20.12292,20.12292,0,0,0,12,4H184Zm40-40H208V116a20.0226,20.0226,0,0,0-20-20H120L93.333,76a20.12292,20.12292,0,0,0-12-4H80V56h40l26.667,20a20.12292,20.12292,0,0,0,12,4H224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganized);
export default __webpack_public_path__ + "static/media/organized.90e02125090eb97f3bda5443df47932e.svg";
export { ForwardRef as ReactComponent };